module.exports = __webpack_public_path__ + "img/WirelessMobileAccess.50178efd.png";